export var EUserLanguage = /*#__PURE__*/function (EUserLanguage) {
  EUserLanguage["ZH_CN"] = "zh-CN";
  EUserLanguage["ZH_HK"] = "zh-HK";
  EUserLanguage["EN_US"] = "en-US";
  return EUserLanguage;
}({});
export var ESsoType = /*#__PURE__*/function (ESsoType) {
  ESsoType["OIDC"] = "OIDC";
  ESsoType["SAML2"] = "SAML2";
  return ESsoType;
}({});
export var ERoleName = /*#__PURE__*/function (ERoleName) {
  ERoleName["Admin"] = "ADMIN";
  return ERoleName;
}({});
export var ECompanySubscriptionType = /*#__PURE__*/function (ECompanySubscriptionType) {
  ECompanySubscriptionType["FREE"] = "FREE";
  ECompanySubscriptionType["CUSTOMIZED"] = "CUSTOMIZED";
  return ECompanySubscriptionType;
}({});
export var EFeature = /*#__PURE__*/function (EFeature) {
  EFeature["USE_HOME"] = "USE_HOME";
  EFeature["USE_HOME_GUIDE"] = "USE_HOME_GUIDE";
  EFeature["USE_HOME_AMI"] = "USE_HOME_AMI";
  EFeature["USE_COMPANY"] = "USE_COMPANY";
  EFeature["USE_COMPANY_BASIC"] = "USE_COMPANY_BASIC";
  EFeature["USE_COMPANY_BOUNDARY"] = "USE_COMPANY_BOUNDARY";
  EFeature["USE_COMPANY_SUPPLIER"] = "USE_COMPANY_SUPPLIER";
  EFeature["USE_COMPANY_USER"] = "USE_COMPANY_USER";
  EFeature["USE_COMPANY_ROLE"] = "USE_COMPANY_ROLE";
  EFeature["USE_CORP"] = "USE_CORP";
  EFeature["USE_CORP_MATERIALITY"] = "USE_CORP_MATERIALITY";
  EFeature["USE_CORP_FRAMEWORK"] = "USE_CORP_FRAMEWORK";
  EFeature["USE_CORP_TASK"] = "USE_CORP_TASK";
  EFeature["EDIT_CORP_TASK_DEADLINE"] = "EDIT_CORP_TASK_DEADLINE";
  EFeature["USE_CORP_KPI"] = "USE_CORP_KPI";
  EFeature["EDIT_CORP_KPI_TARGET"] = "EDIT_CORP_KPI_TARGET";
  EFeature["USE_CORP_DATABASE"] = "USE_CORP_DATABASE";
  EFeature["USE_CORP_REPORT"] = "USE_CORP_REPORT";
  EFeature["EDIT_CORP_REPORT"] = "EDIT_CORP_REPORT";
  EFeature["USE_CORP_ROOT_APPROVAL"] = "USE_CORP_ROOT_APPROVAL";
  EFeature["USE_CARBON"] = "USE_CARBON";
  EFeature["USE_CARBON_ACCOUNTING"] = "USE_CARBON_ACCOUNTING";
  EFeature["USE_CARBON_ACCOUNTING_SETTING"] = "USE_CARBON_ACCOUNTING_SETTING";
  EFeature["USE_CARBON_ACCOUNTING_TASK"] = "USE_CARBON_ACCOUNTING_TASK";
  EFeature["USE_CARBON_ACCOUNTING_INPUT"] = "USE_CARBON_ACCOUNTING_INPUT";
  EFeature["USE_CARBON_ACCOUNTING_REVIEW"] = "USE_CARBON_ACCOUNTING_REVIEW";
  EFeature["USE_CARBON_ACCOUNTING_RESULT"] = "USE_CARBON_ACCOUNTING_RESULT";
  EFeature["USE_CARBON_ACCOUNTING_FLOW"] = "USE_CARBON_ACCOUNTING_FLOW";
  EFeature["USE_CARBON_REPORT"] = "USE_CARBON_REPORT";
  EFeature["USE_CARBON_REDUCTION"] = "USE_CARBON_REDUCTION";
  EFeature["USE_CARBON_REDUCTION_MEASURE"] = "USE_CARBON_REDUCTION_MEASURE";
  EFeature["USE_CARBON_REDUCTION_TARGET"] = "USE_CARBON_REDUCTION_TARGET";
  EFeature["USE_CARBON_REDUCTION_PLAN"] = "USE_CARBON_REDUCTION_PLAN";
  EFeature["USE_CARBON_REDUCTION_PATH"] = "USE_CARBON_REDUCTION_PATH";
  EFeature["USE_CARBON_OFFSET"] = "USE_CARBON_OFFSET";
  EFeature["USE_CARBON_OVERVIEW"] = "USE_CARBON_OVERVIEW";
  EFeature["USE_CARBON_CFP"] = "USE_CARBON_CFP";
  EFeature["USE_CARBON_CFP_ACCOUNTING"] = "USE_CARBON_CFP_ACCOUNTING";
  EFeature["USE_CARBON_CFP_MODEL"] = "USE_CARBON_CFP_MODEL";
  EFeature["USE_SC"] = "USE_SC";
  EFeature["USE_SC_DIR"] = "USE_SC_DIR";
  EFeature["USE_SC_VERIFICATION"] = "USE_SC_VERIFICATION";
  EFeature["USE_SC_VERIFICATION_CREATE"] = "USE_SC_VERIFICATION_CREATE";
  EFeature["USE_SC_VERIFICATION_TASK"] = "USE_SC_VERIFICATION_TASK";
  EFeature["USE_SC_KPI"] = "USE_SC_KPI";
  EFeature["USE_SC_KPI_TARGET"] = "USE_SC_KPI_TARGET";
  EFeature["USE_SC_KPI_ANALYSIS"] = "USE_SC_KPI_ANALYSIS";
  EFeature["USE_SC_DATA"] = "USE_SC_DATA";
  EFeature["USE_PORTFOLIO"] = "USE_PORTFOLIO";
  EFeature["USE_PORTFOLIO_OVERVIEW"] = "USE_PORTFOLIO_OVERVIEW";
  EFeature["USE_PORTFOLIO_DIRECTORY"] = "USE_PORTFOLIO_DIRECTORY";
  EFeature["USE_PORTFOLIO_TASK"] = "USE_PORTFOLIO_TASK";
  EFeature["USE_PORTFOLIO_FRAMEWORK"] = "USE_PORTFOLIO_FRAMEWORK";
  EFeature["USE_PORTFOLIO_DATA"] = "USE_PORTFOLIO_DATA";
  EFeature["USE_PORTFOLIO_CONTROVERSIES"] = "USE_PORTFOLIO_CONTROVERSIES";
  EFeature["USE_REQUEST"] = "USE_REQUEST";
  EFeature["USE_OCR"] = "USE_OCR";
  EFeature["USE_CDP"] = "USE_CDP";
  EFeature["USE_CLIMATE"] = "USE_CLIMATE";
  EFeature["USE_INDUSTRY"] = "USE_INDUSTRY";
  EFeature["USE_RATING"] = "USE_RATING";
  EFeature["USE_IND_STANDARD"] = "USE_IND_STANDARD";
  EFeature["USE_IND_LIBRARY"] = "USE_IND_LIBRARY";
  EFeature["USE_DOCUMENTS"] = "USE_DOCUMENTS";
  return EFeature;
}({});
export var ESystemCustomCompanyType = /*#__PURE__*/function (ESystemCustomCompanyType) {
  ESystemCustomCompanyType["DEMO"] = "DEMO";
  ESystemCustomCompanyType["TRIAL"] = "TRIAL";
  ESystemCustomCompanyType["PROD"] = "PROD";
  ESystemCustomCompanyType["GLOBAL"] = "GLOBAL";
  ESystemCustomCompanyType["NULL"] = "NULL";
  return ESystemCustomCompanyType;
}({});